
//聊天列表
const dialogues = {
  init: function () {

  },

  items: [{
    "mid": 1, //消息的id 唯一标识，重要
    "type": "group",
    "group_name": "讨论群",
    "group_qrCode": "",
    "read": true, //true；已读 false：未读
    "newMsgCount": 1,
    "quiet": false, // true：消息免打扰 false：提示此好友/群的新消息
    "msg": [{ //对话框的聊天记录 新消息 push 进
      "text": "填坑小能手",
      "date": 1488117964495,
      "name": "阿荡",
      "icon": "https://sinacloud.net/vue-wechat/images/headers/header01.png"
    }, {
      "text": '填坑小能手',
      "date": 1488117964495,
      "name": "阿荡",
      "icon": "https://sinacloud.net/vue-wechat/images/headers/header01.png"
    },],
    "user": [{ //昵称备注都有的朋友
      "wxid": "wxid_zhaohd",
      "initial": 'z',
      "icon": "https://sinacloud.net/vue-wechat/images/headers/header01.png",
      "nickname": "阿荡",
      "sex": 1,
      "remark": "阿荡",
      "signature": "填坑小能手",
      "telphone": 18896586152,
      "album": [{
        imgSrc: ""
      }],
      "area": ["中国", "北京", "海淀"],
      "from": "",
      "tag": "",
      "desc": {}
    }, { //昵称备注都有的朋友
      "wxid": "wxid_zhaohd1",
      "initial": 'z',
      "icon": "https://sinacloud.net/vue-wechat/images/headers/header01.png",
      "nickname": "阿荡",
      "sex": 1,
      "remark": "阿荡",
      "signature": "填坑小能手",
      "telphone": 18896586152,
      "album": [{
        imgSrc: ""
      }],
      "area": ["中国", "北京", "海淀"],
      "from": "",
      "tag": "",
      "desc": {}
    }]
  }]

}
export default dialogues;



// WEBPACK FOOTER //
// ./src/store/data/dialogues.js